import { NavLink } from 'react-router-dom';
// Chakra imports
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Text,
  useColorModeValue,
  useToast,
} from '@chakra-ui/react';
// Custom components
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../../../auth-context/auth.context';
import AuthApi from '../../../api/auth';
import DefaultAuth from 'layouts/auth/Default';
// Assets
import illustration from 'assets/img/auth/auth.png';

function ResetPassword() {
  const [email, setEmail] = useState('');
  const [buttonText, setButtonText] = useState('Next');
  const [error, setError] = useState(undefined);
  const history = useHistory();
  const toast = useToast();

  // Chakra color mode
  const textColor = useColorModeValue('navy.700', 'white');
  const textColorSecondary = 'gray.400';
  const textColorDetails = useColorModeValue('navy.700', 'secondaryGray.600');
  const textColorBrand = useColorModeValue('brand.500', 'white');

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const register = async (event) => {
    if (event) {
      event.preventDefault();
    }
    if (!email) {
      return setError('You must enter your email.');
    }
    if (!validateEmail(email)) {
      return setError('You must enter a valid email address.');
    }
    try {
      let response = await AuthApi.ResetPassword({ email });
      response = response.data;
      if (response.status_code !== 200 && response.message) {
        return setError(response.message);
      }
      if (response.status_code === 200 && response.message) {
        toast({
          title: response.message,
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
        setButtonText('Proceed to Login');
        history.push('/auth/sign-in');
      }
      return history.push('/auth/sign-in');
    } catch (err) {
      console.log(err);
      if (err.response) {
        return setError(err.response.data.msg);
      }
      return setError('There has been an error.');
    }
  };

  return (
    <DefaultAuth illustrationBackground={illustration} image={illustration}>
      <Flex
        maxW={{ base: '100%', md: 'max-content' }}
        w='100%'
        mx={{ base: 'auto', lg: '0px' }}
        me='auto'
        h='100%'
        alignItems='start'
        justifyContent='center'
        mb={{ base: '30px', md: '60px' }}
        px={{ base: '25px', md: '0px' }}
        mt={{ base: '40px', md: '14vh' }}
        flexDirection='column'
      >
        <Box me='auto'>
          <Heading color={textColor} fontSize='36px' mb='10px'>
            Reset Password
          </Heading>
          <Text
            mb='36px'
            ms='4px'
            color={textColorSecondary}
            fontWeight='400'
            fontSize='md'
          >
            Enter the verified email address, and we’ll send you a link to set
            password
          </Text>
        </Box>
        <Flex
          zIndex='2'
          direction='column'
          w={{ base: '100%', md: '420px' }}
          maxW='100%'
          background='transparent'
          borderRadius='15px'
          mx={{ base: 'auto', lg: 'unset' }}
          me='auto'
          mb={{ base: '20px', md: 'auto' }}
        >
          <h4
            style={{
              fontSize: '.9em',
              color: 'red',
              textAlign: 'center',
              fontWeight: 400,
              transition: '.2s all',
            }}
          >
            {error}
          </h4>
          <FormControl isRequired isInvalid={error}>
            <FormLabel
              display='flex'
              ms='4px'
              fontSize='sm'
              fontWeight='500'
              color={textColor}
              mb='8px'
            >
              Email
            </FormLabel>
            <Input
              variant='auth'
              isRequired={true}
              ms={{ base: '0px', md: '0px' }}
              type='email'
              placeholder='email'
              mb='24px'
              fontWeight='500'
              size='lg'
              onChange={(event) => {
                setEmail(event.target.value);
                setError(undefined);
              }}
            />
            {/* {error && (
              <Text color='red.500' fontSize='sm' mt='2'>
                {error}
              </Text>
            )} */}
            <Button
              fontSize='sm'
              variant='brand'
              fontWeight='500'
              w='100%'
              h='50'
              mb='24px'
              onClick={register}
            >
              {buttonText}
            </Button>
          </FormControl>
          <Flex
            flexDirection='column'
            justifyContent='center'
            alignItems='start'
            maxW='100%'
            mt='0px'
          >
            <Text color={textColorDetails} fontWeight='400' fontSize='14px'>
              Remember Password?
              <NavLink to='/auth/sign-in'>
                <Text
                  color={textColorBrand}
                  as='span'
                  ms='5px'
                  fontWeight='500'
                >
                  Login
                </Text>
              </NavLink>
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </DefaultAuth>
  );
}

export default ResetPassword;
